var map = {
	"./block_0uboard.js": "./src/playground/blocks/hardware/block_0uboard.js",
	"./block_CloverSEntry1.js": "./src/playground/blocks/hardware/block_CloverSEntry1.js",
	"./block_ITPLE_board.js": "./src/playground/blocks/hardware/block_ITPLE_board.js",
	"./block_KKMOO.js": "./src/playground/blocks/hardware/block_KKMOO.js",
	"./block_KRC.js": "./src/playground/blocks/hardware/block_KRC.js",
	"./block_LineCoding.js": "./src/playground/blocks/hardware/block_LineCoding.js",
	"./block_Lline.js": "./src/playground/blocks/hardware/block_Lline.js",
	"./block_RichShield.js": "./src/playground/blocks/hardware/block_RichShield.js",
	"./block_abilix_Krypton0.js": "./src/playground/blocks/hardware/block_abilix_Krypton0.js",
	"./block_aiot.js": "./src/playground/blocks/hardware/block_aiot.js",
	"./block_albert.js": "./src/playground/blocks/hardware/block_albert.js",
	"./block_albert_ai.js": "./src/playground/blocks/hardware/block_albert_ai.js",
	"./block_altino.js": "./src/playground/blocks/hardware/block_altino.js",
	"./block_altino_lite.js": "./src/playground/blocks/hardware/block_altino_lite.js",
	"./block_altino_neo.js": "./src/playground/blocks/hardware/block_altino_neo.js",
	"./block_alux_connect.js": "./src/playground/blocks/hardware/block_alux_connect.js",
	"./block_alux_nemo.js": "./src/playground/blocks/hardware/block_alux_nemo.js",
	"./block_alux_technic.js": "./src/playground/blocks/hardware/block_alux_technic.js",
	"./block_ardublock.js": "./src/playground/blocks/hardware/block_ardublock.js",
	"./block_arduino.js": "./src/playground/blocks/hardware/block_arduino.js",
	"./block_arduino_cake.js": "./src/playground/blocks/hardware/block_arduino_cake.js",
	"./block_arduino_ext.js": "./src/playground/blocks/hardware/block_arduino_ext.js",
	"./block_arduino_nano.js": "./src/playground/blocks/hardware/block_arduino_nano.js",
	"./block_armz.js": "./src/playground/blocks/hardware/block_armz.js",
	"./block_asomebot.js": "./src/playground/blocks/hardware/block_asomebot.js",
	"./block_asomekit.js": "./src/playground/blocks/hardware/block_asomekit.js",
	"./block_avatarbot.js": "./src/playground/blocks/hardware/block_avatarbot.js",
	"./block_bingles.js": "./src/playground/blocks/hardware/block_bingles.js",
	"./block_bitbrick.js": "./src/playground/blocks/hardware/block_bitbrick.js",
	"./block_blacksmith.js": "./src/playground/blocks/hardware/block_blacksmith.js",
	"./block_bridge.js": "./src/playground/blocks/hardware/block_bridge.js",
	"./block_brown.js": "./src/playground/blocks/hardware/block_brown.js",
	"./block_byrobot_base.js": "./src/playground/blocks/hardware/block_byrobot_base.js",
	"./block_byrobot_controller_3_4.js": "./src/playground/blocks/hardware/block_byrobot_controller_3_4.js",
	"./block_byrobot_controller_4.js": "./src/playground/blocks/hardware/block_byrobot_controller_4.js",
	"./block_byrobot_drone_3_10.js": "./src/playground/blocks/hardware/block_byrobot_drone_3_10.js",
	"./block_byrobot_drone_4.js": "./src/playground/blocks/hardware/block_byrobot_drone_4.js",
	"./block_byrobot_drone_8.js": "./src/playground/blocks/hardware/block_byrobot_drone_8.js",
	"./block_byrobot_dronefighter_controller.js": "./src/playground/blocks/hardware/block_byrobot_dronefighter_controller.js",
	"./block_byrobot_dronefighter_drive.js": "./src/playground/blocks/hardware/block_byrobot_dronefighter_drive.js",
	"./block_byrobot_dronefighter_flight.js": "./src/playground/blocks/hardware/block_byrobot_dronefighter_flight.js",
	"./block_byrobot_petrone_v2_base.js": "./src/playground/blocks/hardware/block_byrobot_petrone_v2_base.js",
	"./block_byrobot_petrone_v2_controller.js": "./src/playground/blocks/hardware/block_byrobot_petrone_v2_controller.js",
	"./block_byrobot_petrone_v2_drive.js": "./src/playground/blocks/hardware/block_byrobot_petrone_v2_drive.js",
	"./block_byrobot_petrone_v2_flight.js": "./src/playground/blocks/hardware/block_byrobot_petrone_v2_flight.js",
	"./block_c3coding_arduino.js": "./src/playground/blocks/hardware/block_c3coding_arduino.js",
	"./block_castarter_v2.js": "./src/playground/blocks/hardware/block_castarter_v2.js",
	"./block_cheese.js": "./src/playground/blocks/hardware/block_cheese.js",
	"./block_choco.js": "./src/playground/blocks/hardware/block_choco.js",
	"./block_choco2.js": "./src/playground/blocks/hardware/block_choco2.js",
	"./block_chocopi.js": "./src/playground/blocks/hardware/block_chocopi.js",
	"./block_coalaboard.js": "./src/playground/blocks/hardware/block_coalaboard.js",
	"./block_cobl.js": "./src/playground/blocks/hardware/block_cobl.js",
	"./block_coco.js": "./src/playground/blocks/hardware/block_coco.js",
	"./block_coconut.js": "./src/playground/blocks/hardware/block_coconut.js",
	"./block_codeino.js": "./src/playground/blocks/hardware/block_codeino.js",
	"./block_codestar.js": "./src/playground/blocks/hardware/block_codestar.js",
	"./block_codewiz.js": "./src/playground/blocks/hardware/block_codewiz.js",
	"./block_coding_box.js": "./src/playground/blocks/hardware/block_coding_box.js",
	"./block_codingmachine.js": "./src/playground/blocks/hardware/block_codingmachine.js",
	"./block_cp_moving.js": "./src/playground/blocks/hardware/block_cp_moving.js",
	"./block_creamo.js": "./src/playground/blocks/hardware/block_creamo.js",
	"./block_cremaker_3Dpen.js": "./src/playground/blocks/hardware/block_cremaker_3Dpen.js",
	"./block_cue.js": "./src/playground/blocks/hardware/block_cue.js",
	"./block_dadublock.js": "./src/playground/blocks/hardware/block_dadublock.js",
	"./block_dalgona.js": "./src/playground/blocks/hardware/block_dalgona.js",
	"./block_dalgona_basic.js": "./src/playground/blocks/hardware/block_dalgona_basic.js",
	"./block_dash.js": "./src/playground/blocks/hardware/block_dash.js",
	"./block_davinci.js": "./src/playground/blocks/hardware/block_davinci.js",
	"./block_diaboard.js": "./src/playground/blocks/hardware/block_diaboard.js",
	"./block_dodaland.js": "./src/playground/blocks/hardware/block_dodaland.js",
	"./block_dplay.js": "./src/playground/blocks/hardware/block_dplay.js",
	"./block_eduino.js": "./src/playground/blocks/hardware/block_eduino.js",
	"./block_edumaker.js": "./src/playground/blocks/hardware/block_edumaker.js",
	"./block_elio.js": "./src/playground/blocks/hardware/block_elio.js",
	"./block_etboard.js": "./src/playground/blocks/hardware/block_etboard.js",
	"./block_etkit.js": "./src/playground/blocks/hardware/block_etkit.js",
	"./block_ev3.js": "./src/playground/blocks/hardware/block_ev3.js",
	"./block_exmars_cube.js": "./src/playground/blocks/hardware/block_exmars_cube.js",
	"./block_firmtech2.js": "./src/playground/blocks/hardware/block_firmtech2.js",
	"./block_freearduino.js": "./src/playground/blocks/hardware/block_freearduino.js",
	"./block_freelinker2.js": "./src/playground/blocks/hardware/block_freelinker2.js",
	"./block_funboard.js": "./src/playground/blocks/hardware/block_funboard.js",
	"./block_gbot.js": "./src/playground/blocks/hardware/block_gbot.js",
	"./block_genirobot.js": "./src/playground/blocks/hardware/block_genirobot.js",
	"./block_hamster.js": "./src/playground/blocks/hardware/block_hamster.js",
	"./block_hamster_s.js": "./src/playground/blocks/hardware/block_hamster_s.js",
	"./block_handino.js": "./src/playground/blocks/hardware/block_handino.js",
	"./block_hasseam.js": "./src/playground/blocks/hardware/block_hasseam.js",
	"./block_hexaboard.js": "./src/playground/blocks/hardware/block_hexaboard.js",
	"./block_hummingbird.js": "./src/playground/blocks/hardware/block_hummingbird.js",
	"./block_hyact.js": "./src/playground/blocks/hardware/block_hyact.js",
	"./block_iCOBOT.js": "./src/playground/blocks/hardware/block_iCOBOT.js",
	"./block_iboard.js": "./src/playground/blocks/hardware/block_iboard.js",
	"./block_iotsmartfarm.js": "./src/playground/blocks/hardware/block_iotsmartfarm.js",
	"./block_jcboard.js": "./src/playground/blocks/hardware/block_jcboard.js",
	"./block_jdcode.js": "./src/playground/blocks/hardware/block_jdcode.js",
	"./block_jdkit.js": "./src/playground/blocks/hardware/block_jdkit.js",
	"./block_jikko.js": "./src/playground/blocks/hardware/block_jikko.js",
	"./block_jikko_basic.js": "./src/playground/blocks/hardware/block_jikko_basic.js",
	"./block_jikko_lidoc.js": "./src/playground/blocks/hardware/block_jikko_lidoc.js",
	"./block_jikko_make.js": "./src/playground/blocks/hardware/block_jikko_make.js",
	"./block_jinirobot_aibot.js": "./src/playground/blocks/hardware/block_jinirobot_aibot.js",
	"./block_jinirobot_toybot.js": "./src/playground/blocks/hardware/block_jinirobot_toybot.js",
	"./block_joystick.js": "./src/playground/blocks/hardware/block_joystick.js",
	"./block_kaboino.js": "./src/playground/blocks/hardware/block_kaboino.js",
	"./block_kaduino.js": "./src/playground/blocks/hardware/block_kaduino.js",
	"./block_kamibot.js": "./src/playground/blocks/hardware/block_kamibot.js",
	"./block_kamibotPi.js": "./src/playground/blocks/hardware/block_kamibotPi.js",
	"./block_kingcoding.js": "./src/playground/blocks/hardware/block_kingcoding.js",
	"./block_lecoboard.js": "./src/playground/blocks/hardware/block_lecoboard.js",
	"./block_lecoboardAvr.js": "./src/playground/blocks/hardware/block_lecoboardAvr.js",
	"./block_lecoboardAvrBT.js": "./src/playground/blocks/hardware/block_lecoboardAvrBT.js",
	"./block_littlebits.js": "./src/playground/blocks/hardware/block_littlebits.js",
	"./block_magkinder.js": "./src/playground/blocks/hardware/block_magkinder.js",
	"./block_makermate.js": "./src/playground/blocks/hardware/block_makermate.js",
	"./block_mechanicblock_controller.js": "./src/playground/blocks/hardware/block_mechanicblock_controller.js",
	"./block_mechanicblock_uno.js": "./src/playground/blocks/hardware/block_mechanicblock_uno.js",
	"./block_mechanicblock_uno_mini.js": "./src/playground/blocks/hardware/block_mechanicblock_uno_mini.js",
	"./block_mechanicblock_uno_s.js": "./src/playground/blocks/hardware/block_mechanicblock_uno_s.js",
	"./block_mechatro.js": "./src/playground/blocks/hardware/block_mechatro.js",
	"./block_mechatronics_4d.js": "./src/playground/blocks/hardware/block_mechatronics_4d.js",
	"./block_memaker.js": "./src/playground/blocks/hardware/block_memaker.js",
	"./block_microbit.js": "./src/playground/blocks/hardware/block_microbit.js",
	"./block_microbit2.js": "./src/playground/blocks/hardware/block_microbit2.js",
	"./block_microbit_ext.js": "./src/playground/blocks/hardware/block_microbit_ext.js",
	"./block_mindpiggy.js": "./src/playground/blocks/hardware/block_mindpiggy.js",
	"./block_mkboard.js": "./src/playground/blocks/hardware/block_mkboard.js",
	"./block_modi.js": "./src/playground/blocks/hardware/block_modi.js",
	"./block_mrt.js": "./src/playground/blocks/hardware/block_mrt.js",
	"./block_nemoino.js": "./src/playground/blocks/hardware/block_nemoino.js",
	"./block_neo.js": "./src/playground/blocks/hardware/block_neo.js",
	"./block_neo_cannon.js": "./src/playground/blocks/hardware/block_neo_cannon.js",
	"./block_neo_spider.js": "./src/playground/blocks/hardware/block_neo_spider.js",
	"./block_neobot.js": "./src/playground/blocks/hardware/block_neobot.js",
	"./block_neobot_game_theme.js": "./src/playground/blocks/hardware/block_neobot_game_theme.js",
	"./block_neobot_purple.js": "./src/playground/blocks/hardware/block_neobot_purple.js",
	"./block_neobot_robot_theme.js": "./src/playground/blocks/hardware/block_neobot_robot_theme.js",
	"./block_neobot_sensor_theme.js": "./src/playground/blocks/hardware/block_neobot_sensor_theme.js",
	"./block_neobot_soco.js": "./src/playground/blocks/hardware/block_neobot_soco.js",
	"./block_neobot_thinkcar.js": "./src/playground/blocks/hardware/block_neobot_thinkcar.js",
	"./block_orange.js": "./src/playground/blocks/hardware/block_orange.js",
	"./block_ozobot.js": "./src/playground/blocks/hardware/block_ozobot.js",
	"./block_palmkit.js": "./src/playground/blocks/hardware/block_palmkit.js",
	"./block_pingpong.js": "./src/playground/blocks/hardware/block_pingpong.js",
	"./block_pingpong_multi.js": "./src/playground/blocks/hardware/block_pingpong_multi.js",
	"./block_playcode.js": "./src/playground/blocks/hardware/block_playcode.js",
	"./block_plrun.js": "./src/playground/blocks/hardware/block_plrun.js",
	"./block_robico.js": "./src/playground/blocks/hardware/block_robico.js",
	"./block_robodog.js": "./src/playground/blocks/hardware/block_robodog.js",
	"./block_roboid.js": "./src/playground/blocks/hardware/block_roboid.js",
	"./block_robolink_codrone_diy.js": "./src/playground/blocks/hardware/block_robolink_codrone_diy.js",
	"./block_robolink_codrone_edu.js": "./src/playground/blocks/hardware/block_robolink_codrone_edu.js",
	"./block_robolink_codrone_mini.js": "./src/playground/blocks/hardware/block_robolink_codrone_mini.js",
	"./block_robomation.js": "./src/playground/blocks/hardware/block_robomation.js",
	"./block_roborobo_base.js": "./src/playground/blocks/hardware/block_roborobo_base.js",
	"./block_roborobo_cube.js": "./src/playground/blocks/hardware/block_roborobo_cube.js",
	"./block_roborobo_robokit_rs.js": "./src/playground/blocks/hardware/block_roborobo_robokit_rs.js",
	"./block_roborobo_roduino.js": "./src/playground/blocks/hardware/block_roborobo_roduino.js",
	"./block_roborobo_roe.js": "./src/playground/blocks/hardware/block_roborobo_roe.js",
	"./block_roborobo_schoolkit.js": "./src/playground/blocks/hardware/block_roborobo_schoolkit.js",
	"./block_robotamicoding.js": "./src/playground/blocks/hardware/block_robotamicoding.js",
	"./block_robotis.js": "./src/playground/blocks/hardware/block_robotis.js",
	"./block_robotisDream.js": "./src/playground/blocks/hardware/block_robotisDream.js",
	"./block_robotisRB.js": "./src/playground/blocks/hardware/block_robotisRB.js",
	"./block_robotisRBCar.js": "./src/playground/blocks/hardware/block_robotisRBCar.js",
	"./block_robotisRBHumanoid.js": "./src/playground/blocks/hardware/block_robotisRBHumanoid.js",
	"./block_robotisRBKoala.js": "./src/playground/blocks/hardware/block_robotisRBKoala.js",
	"./block_robotisRBPracticalAssembly.js": "./src/playground/blocks/hardware/block_robotisRBPracticalAssembly.js",
	"./block_robotori.js": "./src/playground/blocks/hardware/block_robotori.js",
	"./block_robotry_parodule.js": "./src/playground/blocks/hardware/block_robotry_parodule.js",
	"./block_robotry_robit_stage.js": "./src/playground/blocks/hardware/block_robotry_robit_stage.js",
	"./block_rokoboard.js": "./src/playground/blocks/hardware/block_rokoboard.js",
	"./block_runcoding.js": "./src/playground/blocks/hardware/block_runcoding.js",
	"./block_sally.js": "./src/playground/blocks/hardware/block_sally.js",
	"./block_sciencecube.js": "./src/playground/blocks/hardware/block_sciencecube.js",
	"./block_sensorboard.js": "./src/playground/blocks/hardware/block_sensorboard.js",
	"./block_smartCodingHouse.js": "./src/playground/blocks/hardware/block_smartCodingHouse.js",
	"./block_smartboard.js": "./src/playground/blocks/hardware/block_smartboard.js",
	"./block_ssboard_nano.js": "./src/playground/blocks/hardware/block_ssboard_nano.js",
	"./block_suno.js": "./src/playground/blocks/hardware/block_suno.js",
	"./block_talebot.js": "./src/playground/blocks/hardware/block_talebot.js",
	"./block_telliot_Base.js": "./src/playground/blocks/hardware/block_telliot_Base.js",
	"./block_telliot_lite.js": "./src/playground/blocks/hardware/block_telliot_lite.js",
	"./block_thinkboard.js": "./src/playground/blocks/hardware/block_thinkboard.js",
	"./block_timbo.js": "./src/playground/blocks/hardware/block_timbo.js",
	"./block_truerobot.js": "./src/playground/blocks/hardware/block_truerobot.js",
	"./block_turtle.js": "./src/playground/blocks/hardware/block_turtle.js",
	"./block_uglybot.js": "./src/playground/blocks/hardware/block_uglybot.js",
	"./block_uo_albert.js": "./src/playground/blocks/hardware/block_uo_albert.js",
	"./block_wearable.js": "./src/playground/blocks/hardware/block_wearable.js",
	"./block_whalesbot_eagle_1001.js": "./src/playground/blocks/hardware/block_whalesbot_eagle_1001.js",
	"./block_xbot.js": "./src/playground/blocks/hardware/block_xbot.js",
	"./block_zerone.js": "./src/playground/blocks/hardware/block_zerone.js",
	"./block_zumiMini.js": "./src/playground/blocks/hardware/block_zumiMini.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/playground/blocks/hardware sync ^(?%21.*index.js)((.*\\.(js\\.*))[^.]*$)im";